import { render, staticRenderFns } from "./GroupConfig.vue?vue&type=template&id=4691a674&scoped=true"
import script from "./GroupConfig.vue?vue&type=script&lang=js"
export * from "./GroupConfig.vue?vue&type=script&lang=js"
import style0 from "./GroupConfig.vue?vue&type=style&index=0&id=4691a674&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4691a674",
  null
  
)

export default component.exports